import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackVirtualPageView } from '../../utils/analytics';

/**
 * Pushes `virtual_page_view` to the dataLayer on every client-side route change.
 *
 * - The first page is skipped: the GTM snippet's own gtm.js / page load covers it.
 * - useLayoutEffect (not useEffect) so this runs before the new page's useEffect
 *   ecommerce events (e.g. begin_checkout), keeping prod's order: page view, then event.
 * - Keyed on location.key so StrictMode's double-invoke doesn't push twice.
 * - Direct window.history.pushState/replaceState calls (style modal, combo page) don't
 *   go through the router, so they don't count as page views.
 */
const RouteChangeTracker = () => {
  const location = useLocation();
  const lastKeyRef = useRef(null);

  useLayoutEffect(() => {
    if (lastKeyRef.current === null) {
      lastKeyRef.current = location.key;
      return;
    }
    if (lastKeyRef.current === location.key) return;
    lastKeyRef.current = location.key;
    trackVirtualPageView();
  }, [location.key]);

  return null;
};

export default RouteChangeTracker;
